export const SERVICE_TYPE = {
	// NONE: 0,
	PICKUP: 1,
	TAKEOUT: 2,
	DELIVERY: 3,
	DRIVE_THRU: 4,
	SEATED: 5,
	CURBSIDE: 9,
	BILL_ONLY: 10,
	// FEEDBACK_ONLY: 11,
	WASTE: 12,
} as const;
export type TServiceType = typeof SERVICE_TYPE[keyof typeof SERVICE_TYPE];


// export const SERVICE_TYPE_LABELS = {
// 	[SERVICE_TYPE.PICKUP]: 'Dine-in',
// 	[SERVICE_TYPE.TAKEOUT]: 'To-Go',
// 	[SERVICE_TYPE.DRIVE_THRU]: 'Drive Thru',
// 	[SERVICE_TYPE.DELIVERY]: 'Delivery',
// 	[SERVICE_TYPE.BILL_ONLY]: 'DBF',
// 	[SERVICE_TYPE.CURBSIDE]: 'Curbside',
// 	[SERVICE_TYPE.SEATED]: 'Table Service',
// 	[SERVICE_TYPE.WASTE]: 'Waste',
// };

export const sortServiceTypes = (serviceTypes: TServiceType[]) => {
	return serviceTypes.sort((a, b) => {
		return b - a;
	});
};
